import { RepositoryFactory } from "@/app/repositories/repository-factory.js";
// import Repository from "@/app/repositories/repository";

import topListAll from "../data/topList-all.json";
import topListFitness from "../data/topList-fitness.json";
import topListKitchen from "../data/topList-kitchen.json";
import topListMedical from "../data/topList-medical.json";

import productsFit from "../data/products-fit.json";
import productsFurn from "../data/products-furn.json";
import productsKp from "../data/products-kp.json";
import productsMed from "../data/products-med.json";

import allProducts from "../data/all.json";
import allTreeCatalogs from "../../store.catalog/data/tree.json"

const productRepository = RepositoryFactory.get("product");

export default Object.assign(productRepository, {
  getTopList: function(catalogId, itemsCount){
    //   return Repository.get(`${this.resource}/getTopList?catalogId=${catalogId}&itemsCount=${itemsCount}`);
    if (catalogId === 1){
        return this.getTopListFitness(itemsCount);
    }else if (catalogId === 9){
        return this.getTopListMedical(itemsCount);
    }else if (catalogId === 38){
        return this.getTopListKitchen(itemsCount);
    }else if (catalogId === 47){
        return this.getTopListAll(itemsCount);
    }
  },
  getTopListAll: function (itemsCount) {
    return Promise.resolve({
      data: itemsCount ? topListAll.slice(0, itemsCount) : topListAll,
    });
  },

  getTopListFitness: function (itemsCount) {
    return Promise.resolve({
      data: itemsCount ? topListFitness.slice(0, itemsCount) : topListFitness,
    });
  },

  getTopListKitchen: function (itemsCount) {
    return Promise.resolve({
      data: itemsCount ? topListKitchen.slice(0, itemsCount) : topListKitchen,
    });
  },

  getTopListMedical: function (itemsCount) {
    return Promise.resolve({
      data: itemsCount ? topListMedical.slice(0, itemsCount) : topListMedical,
    });
  },

  getAllJson: function () {
    return Promise.resolve({
      data: allProducts
    });
  },

  getProductById: function (productId){
    let productData = allProducts.find(e=>e.id===productId);
    return Promise.resolve({
      data: productData,
    });
  },
  getProductsByCatalogId: function (catalogId) {
    // return Repository.get(
    //   `/product/getProductsByCatalogId?catalogId=` + catalogId,
    // );
    let catalogFound = allTreeCatalogs.find(e=>e.id === catalogId);
    let productsFound = [];
    if (catalogFound){
      if (catalogFound.isMainCategory){
        let catalogFoundChildrenIds = catalogFound.children?.map(e=>e.id);
        productsFound = allProducts.filter(e=>catalogFoundChildrenIds.includes(e.categoryFk));
      }else {
        productsFound = [];
      }
    }else{
      let allTreeCatalogsChildren = allTreeCatalogs.flatMap(e=>e.children);
      catalogFound = allTreeCatalogsChildren.find(e=>e.id === catalogId);
      if (catalogFound){
        productsFound = allProducts.filter(e=>e.categoryFk === catalogFound.id);
      }
    }
    return Promise.resolve({
      data: productsFound,
    });
  },
  getProductsByCatalogSlug: function (catalogSlug) {
    // return Repository.get(
    //   `/product/getProductsByCatalogSlug?catalogSlug=` + catalogSlug,
    // );

    const productsBySlug = {
    "kp": productsKp,
    "project-furniture": productsFurn,
    "home-fitness": productsFit,
    "covide-19-products": productsMed,
  };

  return Promise.resolve({
    data: productsBySlug[catalogSlug] || []
  });

  },
  getAssetsByProductId: function (productId) {
    // return Repository.get(
    //   `/product/getAssetsByProductId?productId=` + productId,
    // );
    let images = [];
    let data = allProducts.find(e=>e.id === productId);
    
    if (data){
      let fileExtension = (data.imgPath + '').split('.');
  
      if (fileExtension && fileExtension.length > 1){
        images = [{
          "id": data.id,
          "fileExtension": '.' + fileExtension[1],
          "guid": fileExtension[0]
        }];
      }
    }

    return Promise.resolve({
      data: images || []
    });
  },
});
